import { createSlice, Dispatch } from "@reduxjs/toolkit";
// utils
import axiosInstance from "../../../api/manageServer";
import { setPaginationOption } from "../filter/filterSlice";
import { get } from "http";

// ----------------------------------------------------------------------

const initialState: any = {
  isLoading: false,
  error: false,
  products: [],
  product: null,
  isProductLoading: false,
  homeProducts: [],
  newestProducts: [],
  bestSellingProducts: [],
  topRatedProducts: [],
  hotDealsProducts: [],
  paginationOption: {
    pageSize: 10,
    page: 1,
    totalRecords: 0,
  },
  productReviews: [],
  reviewLoading: true,
};

const slice = createSlice({
  name: "product",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    startReviewLoading: (state) => {
      state.reviewLoading = true;
    },

    startProductLoading(state) {
      state.isProductLoading = true;
      state.product = null;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET PRODUCTS
    getProductsSuccess(state, action) {
      state.isLoading = false;
      if (action.payload) state.products = action.payload;
    },

    // GET PRODUCT
    getProductSuccess(state, action) {
      state.isProductLoading = false;
      state.product = action.payload;
    },

    getHomeProductsSuccess(state, action) {
      state.isLoading = false;
      if (action.payload) state.homeProducts = action.payload;
    },

    setProductPaginationOption(state, action) {
      state.paginationOption.page = action.payload.page;
      state.paginationOption.pageSize = action.payload.pageSize;
      // state.paginationOption.totalPages = action.payload.totalPages;
      state.paginationOption.totalRecords = action.payload.totalRecords;
    },
    getNewestProductSuccess(state, action) {
      state.isLoading = false;
      state.newestProducts = action.payload;
    },
    getBestSellerProductSuccess(state, action) {
      state.isLoading = false;
      state.bestSellingProducts = action.payload;
    },
    getTopRatedProductSuccess(state, action) {
      state.isLoading = false;
      state.topRatedProducts = action.payload;
    },
    getHotDealProductSuccess(state, action) {
      state.isLoading = false;
      state.hotDealsProducts = action.payload;
    },
    setProductReviews(state, action) {
      state.productReviews = action.payload;
      state.reviewLoading = false;
    },
  },
});

// Reducer
export default slice.reducer;

// export const  {setPaginationOption} = slice.actions;

export const {
  startLoading,
  getHomeProductsSuccess,
  getProductSuccess,
  hasError,
  getProductsSuccess,
  setProductPaginationOption,
  startProductLoading,
  getNewestProductSuccess,
  getBestSellerProductSuccess,
  getTopRatedProductSuccess,
  getHotDealProductSuccess,
  setProductReviews,
  startReviewLoading,
} = slice.actions;

// ----------------------------------------------------------------------

export function getProducts(shop_id: number) {
  return async () => {
    return async (dispatch: any, getState: () => any) => {
      dispatch(startLoading());

      try {
        // console.log(shop_id);
        const response = await axiosInstance.get(
          `/product/shops/business_location/filter?businessLocationId=${shop_id}`
        );
        if (response.status === 200) {
          dispatch(getProductsSuccess(response.data.records));
        }
      } catch (error) {
        dispatch(hasError(error));
      }
    };
  };
}

export function fetchSimilarProductById(
  id: number,
  pageCount?: number,
  pageSize: number = 5
) {
  return async (dispatch: Dispatch, getState: () => any) => {
    dispatch(startLoading());
    try {
      const { selectedBusinessLocation } = getState().businessLocation;
      const businessLocationId = selectedBusinessLocation.id;

      const response = await axiosInstance.get(`/product/similar`, {
        params: {
          id,
          business_location_id: businessLocationId,
          pageCount,
          pageSize,
        },
      });

      dispatch(getProductsSuccess(response.data.records));
    } catch (error) {
      console.error("Error fetching similar product data:", error);
      dispatch(hasError(error));
    }
  };
}

export function getProductById(id: number, business_id: number) {
  console.log("🚀 ~ getProductById ~ id:", id, business_id);
  return async (dispatch: any, getState: () => any) => {
    dispatch(startProductLoading());
    try {
      const response = await axiosInstance.get(
        `/product/shop/product?${id && `productId=${id}`}${
          business_id && `&businessLocationId=${business_id}`
        }`
      );
      dispatch(getProductSuccess(response.data));
    } catch (error) {
      console.log(error);
      dispatch(hasError(error));
    }
  };
}

export function getFilterProducts(
  filters: any,
  price: any,
  paginationOption: {
    page: number;
    pageSize: number;
    totalPages: number;
    totalRecords: number;
  },
  selectedBusinessLocationId: number,
  searchKey?: string,
  promoId?: string
) {
  return async (dispatch: any, getState: () => any) => {
    const user = getState()?.auth?.auth;
    try {
      dispatch(startLoading());
      let req = "";
      await filters.map((filter: any) => {
        if (filter?.title === "Category") {
          filter.filters.map((item: any) => {
            if (item?.selected) {
              req += `&categoryIds=${item?.value}`;
            }
          });
        }
        if (filter?.title === "Brand") {
          filter.filters.map((item: any) => {
            if (item?.selected) {
              req += `&brandIds=${item?.value}`;
            }
          });
        }
        if (filter?.title === "Units") {
          filter.filters.map((item: any) => {
            if (item?.selected) {
              req += `&unitId=${item?.value}`;
            }
          });
        }
        if (filter?.title === "Warranty Type") {
          filter.filters.map((item: any) => {
            if (item?.selected) {
              req += `&warrantyId=${item?.value}`;
            }
          });
        }
        if (filter?.title === "Availability") {
          filter.filters.map((item: any) => {
            if (item?.name === "In Stock" && item?.selected) {
              req += `&inStock=true`;
            } else if (item?.name === "Out of Stock" && item?.selected) {
              req += `&inStock=false`;
            }
          });
        }
        if (filter?.title === "Shipping") {
          filter.filters.map((item: any) => {
            if (item?.name === "Free Shipping" && item?.selected) {
              req += `&isFreeShipping=true`;
            }
          });
        }
        if (filter?.title === "Customer Ratings") {
          filter.filters.map((item: any) => {
            if (item?.selected) {
              req += `&avgRating=${item?.value}`;
            }
          });
        }
      });
      if (price?.minValue) {
        req += `&minPrice=${price?.minValue}`;
      }
      if (price?.maxValue) {
        req += `&maxPrice=${price?.maxValue}`;
      }
      if (paginationOption?.page) {
        req += `&pageCount=${paginationOption?.page}`;
      }
      if (paginationOption?.pageSize) {
        req += `&pageSize=${paginationOption?.pageSize}`;
      }

      if (searchKey) {
        req += `&searchTerm=${searchKey}`;
      }

      if (promoId) {
        req += `&productPromotionId=${promoId}`;
      }

      if (user) {
        if (user?.age < 18) {
          req += `&ageRestriction=false`;
        }
      }

      req += `&businessLocationId=${selectedBusinessLocationId}`;

      const response = await axiosInstance.get(
        `/product/shops/business_location/filter?${req}`
      );
      if (response?.status === 200) {
        dispatch(getProductsSuccess(response.data.records));
        dispatch(
          setPaginationOption({
            page: response.data.pageNumber,
            pageSize: response.data.pageSize,
            totalPages: response.data.totalPages,
            totalRecords: response.data.totalRecords,
          })
        );
      } else {
        dispatch(hasError);
      }
    } catch (error) {
      console.log(error);
    }
  };
}

export function getHomeProducts(
  paginationOption: {
    page: number;
    pageSize: number;
    totalPages: number;
    totalRecords: number;
  },
  selectedBusinessLocationId: number
) {
  // console.log("🚀 ~ paginationOption:", paginationOption)
  return async (dispatch: any, getState: () => any) => {
    dispatch(startLoading());
    const user = getState()?.auth?.auth;
    console.log("🚀 ~ return ~ user:", user);

    try {
      const respone = await axiosInstance.get(
        `/product/shops/business_location/filter?businessLocationId=${selectedBusinessLocationId}&pageCount=1&pageSize=${
          paginationOption?.pageSize
        }${user && user?.age < 18 ? "&ageRestriction=false" : ""}`
      );
      if (respone.status === 200) {
        dispatch(getHomeProductsSuccess(respone.data.records));
        dispatch(
          setProductPaginationOption({
            page: respone.data.page,
            pageSize: paginationOption?.pageSize || 15,
            totalRecords: respone.data.totalRecords,
          })
        );
      }
    } catch (error) {
      console.log(error);
    }
  };
}
// export function getBestSellerProduct(page?: number, size?: number) {
//   return async (dispatch: Dispatch, getState: () => any) => {
//     dispatch(startLoading());
//     try {
//       const { selectedBusinessLocation } = getState().businessLocation;
//       const businessLocationId = selectedBusinessLocation.id;

//       const response = await axiosInstance.get(`/best-seller-products`, {
//         params: {
//           businessLocationId: businessLocationId,
//           page,
//           size,
//         },
//       });

//       dispatch(getBestSellerProductSuccess(response.data.records));
//     } catch (error) {
//       console.error("Error fetching best seller product data:", error);
//       dispatch(hasError(error));
//     }
//   };
// };
export function getBestSellerProduct(page?: number, size?: number) {
  return async (dispatch: Dispatch, getState: () => any) => {
    dispatch(startLoading());
    try {
      const { selectedBusinessLocation } = getState().businessLocation;
      const businessLocationId = selectedBusinessLocation.id;

      const response = await axiosInstance.get(`/best-seller-products`, {
        params: {
          businessLocationId: businessLocationId,
          page,
          size,
        },
      });

      dispatch(getBestSellerProductSuccess(response.data.records));
    } catch (error) {
      console.error("Error fetching best seller product data:", error);
      dispatch(hasError(error));
    }
  };
}

export function getTopRatedProduct(page?: number, size?: number) {
  return async (dispatch: Dispatch, getState: () => any) => {
    dispatch(startLoading());
    try {
      const { selectedBusinessLocation } = getState().businessLocation;
      const businessLocationId = selectedBusinessLocation.id;

      const response = await axiosInstance.get(`/top-rated-products`, {
        params: {
          businessLocationId: businessLocationId,
          page,
          size,
        },
      });

      dispatch(getTopRatedProductSuccess(response.data.records));
    } catch (error) {
      console.error("Error fetching top rated product data:", error);
      dispatch(hasError(error));
    }
  };
}

export function getHotDealsProduct(page?: number, size?: number) {
  return async (dispatch: Dispatch, getState: () => any) => {
    dispatch(startLoading());
    try {
      const { selectedBusinessLocation } = getState().businessLocation;
      const businessLocationId = selectedBusinessLocation.id;

      const response = await axiosInstance.get(`/hot-deals`, {
        params: {
          businessLocationId: businessLocationId,
          page,
          size,
        },
      });

      dispatch(getHotDealProductSuccess(response.data.records));
    } catch (error) {
      console.error("Error fetching hot deal product data:", error);
      dispatch(hasError(error));
    }
  };
}

export function getNewestProduct(page?: number, size?: number) {
  return async (dispatch: Dispatch, getState: () => any) => {
    dispatch(startLoading());
    try {
      const { selectedBusinessLocation } = getState().businessLocation;
      const businessLocationId = selectedBusinessLocation.id;

      const response = await axiosInstance.get(`/newest-products`, {
        params: {
          businessLocationId: businessLocationId,
          page,
          size,
        },
      });

      dispatch(getNewestProductSuccess(response.data.records));
    } catch (error) {
      console.error("Error fetching best newest product data:", error);
      dispatch(hasError(error));
    }
  };
}

export function addReview(
  id: number,
  data: {
    stars: number;
    comment: string;
    reviewerId?: number;
    replyComment?: string;
  },
  reviewImages?: File[]
) {
  return async (dispatch: Dispatch, getState: () => any) => {
    dispatch(startReviewLoading());
    try {
      const reviewRequest = JSON.stringify(data);
      const formData = new FormData();
      formData.append("reviewRequest", reviewRequest);
      formData.append("reviewImages", JSON.stringify(reviewImages));

      const response = await axiosInstance.put(`/review/${id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (response.status === 200) {
        dispatch(setProductReviews(response.data));
      } else {
        throw new Error(response.data.message || "Failed to save review.");
      }
    } catch (error) {
      console.error("Error fetching best newest product data:", error);
      dispatch(hasError(error));
    }
  };
}

export function getProductReviews(
  pageSize: number,
  productId: number,
  userId?: number
) {
  return async (dispatch: Dispatch, getState: () => any) => {
    dispatch(startReviewLoading());
    try {
      const response = await axiosInstance.get(`/review/filter`, {
        params: {
          productId,
          pageSize,
          userId,
        },
      });
      console.log("🚀 ~ return ~ response:", response)
      if (response.status === 200) {
        dispatch(setProductReviews(response.data?.records));
      } else {
        throw new Error(response.data.message || "Failed to save review.");
      }
    } catch (error) {
      console.error("Error fetching best newest product data:", error);
      dispatch(hasError(error));
    }
  };
}
